import { createSlice } from "@reduxjs/toolkit";
import {
  getClientMessages,
  sendClientMessage,
  updateClientMessage,
  getUnreadMessageSummary,
  markClientThreadRead,
  getMessageThreads,
} from "../action/messageAction";
import { messageStoreKey } from "../../utils/clientDetailsCategory";

const initialState = {
  messagesByClientId: {},
  unreadSummary: { unread_count: 0, threads: [] },
  threads: { total_count: 0, threads: [] },
};

export const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getClientMessages.fulfilled, (state, action) => {
      const { clientId, category, messages } = action.payload || {};
      if (!clientId) return;
      state.messagesByClientId[messageStoreKey(clientId, category)] =
        messages || [];
    });

    builder.addCase(sendClientMessage.fulfilled, (state, action) => {
      const { clientId, category, message } = action.payload || {};
      if (!clientId || !message) return;
      const key = messageStoreKey(clientId, category);
      const existing = state.messagesByClientId[key] || [];
      state.messagesByClientId[key] = [...existing, message];
    });

    builder.addCase(updateClientMessage.fulfilled, (state, action) => {
      const { clientId, category, messageId, message } = action.payload || {};
      if (!clientId || !messageId) return;
      const key = messageStoreKey(clientId, category);
      const list = state.messagesByClientId[key] || [];
      state.messagesByClientId[key] = list.map((m) =>
        String(m?.message_id) === String(messageId)
          ? { ...m, ...(message || {}), message: message?.message ?? m.message }
          : m,
      );
    });

    builder.addCase(getUnreadMessageSummary.fulfilled, (state, action) => {
      state.unreadSummary = action.payload || {
        unread_count: 0,
        threads: [],
      };
    });

    builder.addCase(getMessageThreads.fulfilled, (state, action) => {
      state.threads = action.payload || { threads: [], total_count: 0 };
    });

    builder.addCase(markClientThreadRead.fulfilled, (state, action) => {
      const { clientId } = action.payload || {};
      if (!clientId) return;
      const threads = state.unreadSummary?.threads || [];
      state.unreadSummary = {
        ...(state.unreadSummary || {}),
        threads: threads.map((t) =>
          String(t?.client_id) === String(clientId)
            ? { ...t, unread_count: 0 }
            : t,
        ),
      };
      state.unreadSummary.unread_count = (
        state.unreadSummary.threads || []
      ).reduce((sum, t) => sum + Number(t?.unread_count || 0), 0);
    });
  },
});

export default messageSlice.reducer;
